import { render, staticRenderFns } from "./exchange-bulk-item-prev.vue?vue&type=template&id=ccbc5240&scoped=true&"
import script from "./exchange-bulk-item-prev.vue?vue&type=script&lang=js&"
export * from "./exchange-bulk-item-prev.vue?vue&type=script&lang=js&"
import style0 from "./exchange-bulk-item-prev.vue?vue&type=style&index=0&id=ccbc5240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbc5240",
  null
  
)

export default component.exports